<template>
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <card class="strpied-tabled-with-hover"
                  body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <div class="table-header">
                  <h4 class="card-title chart-title">Транзакции</h4>
                </div>
              </template>
              <l-table class="table-hover table-striped"
                       :columns="tableColumns"
                       :data="tableData">
              </l-table>
            </card>
            <div style="display: flex; flex-direction: row;">
              <button @click="prevPage" v-if="offset != 1" style="margin-right: 10px; margin-bottom: 0px; margin-top: 0px;" class="btn btn-primary">
                -
              </button>
              <p style="display: flex; align-items: center; justify-content: center; text-align: center; margin: 0; margin-right: 10px;">
                {{ offset }} / {{ maxPage }}
              </p>
              <button v-if="offset != maxPage - 1" @click="nextPage" style="margin-top: 0px; margin-bottom: 0px;" class="btn btn-primary">
                >
              </button>
              <select style="margin-left: 10px;" @change="setLimit" class="form-select" aria-label="Default select example">
                <option value="20">20 строк</option>
                <option value="50">50 строк</option>
                <option value="70">70 строк</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    import LTable from 'src/components/Table.vue'
    import Card from 'src/components/Cards/Card.vue'
    import api from 'src/api.js'
    export default {
      components: {
        LTable,
        Card
      },
      watch: {
        offset: function() {
          this.getData()
        }
      },
      data() {
        return {
          limit: 20,
          maxPage: 1,
          offset: 1,
          tableColumns: ['date', 'bill', 'type', 'currency', 'amount'],
          tableData: [
            {
                date: 0,
                bill: 0,
                type: 0,
                currency: 0,
                amount: 0
            },
          ]
        }
      },
      mounted() {
        this.getData()
      },  
      methods: {
        setLimit(e) {
          this.limit = e.target.value 
          this.offset = 1
          this.getData()
        },
        nextPage() {
          this.offset++
        },
        prevPage() {
          this.offset -= 1
        },
        getData() {
          api.get(`https://dev.fly7.ru/mb600/hs/dash/transactions?limit=${this.limit}&offset=${this.offset}`).then(response => {
                this.maxPage = response.data.total
                this.tableData = response.data.results
          })
        }
      }
    }
  </script>
  <style lang="sass">
  .table-header 
    display: flex !important
    flex-direction: row !important
    justify-content: space-between !important
  </style>